import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="" />
    <p>
      All rights Reserved. To infinity & beyond <br/><br/> <a href="https://foundingbrokers.com">Founding Brokers</a>
    </p>
  </footer>
);

export default Footer;
